import React from "react";
import headshot1 from "../imgs/headshot-3.jpg";
import "./Homepage.css";
import { Link } from "react-router-dom";

export default function HomePage() {
  return (
    <main className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <h1 className="hero-name">Savannah Chanel</h1>
        <h2 className="hero-title">Web Developer & Audio Engineer</h2>
        {/* <p className="svx-line">
          Founder,{" "}
          <a
            href="https://svx.studio"
            target="_blank"
            rel="noreferrer"
            className="svx-link"
          >
            SVX Studio
          </a>
        </p> */}
        <div className="svx-line" aria-label="SVX Studio">
          <span className="svx-label">Founder &amp; Creative Director</span>
          <span className="svx-dot">•</span>
          <a
            href="https://svx.studio"
            target="_blank"
            rel="noreferrer"
            className="svx-pill"
          >
            SVX Studio
            {/* <span className="svx-arrow">↗</span> */}
          </a>
        </div>
        <p className="hero-text">
          Hey there! I’m a web developer and audio engineer who loves bringing
          ideas to life through creative, engaging digital experiences that
          blend art, design, and technology. Let’s collaborate and build
          something that helps you connect with people.
        </p>
        <div className="hero-actions">
          <Link to="/portfolio" className="cta-btn">
            View Portfolio
          </Link>
          <Link to="/resume" className="cta-btn outline">
            View Résumé
          </Link>
        </div>
      </section>

      {/* Hero Image */}
      <div className="headshot-wrap">
        <img
          className="headshot-img"
          src={headshot1}
          alt="Portrait of Savannah Chanel Victoria"
        />

        <div className="photo-credit" aria-label="Photo credit">
          Picture Credit:{" "}
          <a
            href="https://rachelpiggottphotography.mypixieset.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Rachel Piggott
          </a>
        </div>
      </div>
    </main>
  );
}
